import React, { useEffect, useRef, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { fetchStoreHistory } from "../../../services/centralStore/centralStore"
import moment from "moment"
import { capitalize, isEmpty } from "lodash"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import StockJournalFilter from "./filter"
import { useLocation, useNavigate } from "react-router-dom"

const StockJournalReport = ({ fromDashboard, projectId }) => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Inventory Book${companyname ? ` | ${companyname}` : ''}`;

  const locations = useLocation();
  const bookname = locations?.state?.name || ""
  const crumb = locations?.state?.menuLabel || ""

  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState("")
  const [ccNo, setCCNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [ledgerLocation, setLedgerLocation] = useState("")
  const [financial, setFinancial] = useState(true)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [company, setCompany] = useState(false)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const { control, watch, reset } = useForm({
    defaultValues: {
      req_date: null,
    },
  })
  

  const location = useLocation()
  const navigate = useNavigate()
  const { productId, productName, productCode } = location.state || {}

  console.log(
    productId,
    productName,
    productCode,
    "productId, productName, productCode",
    location
  )

  const handlePaginate = page => {
    setPage(page)
  }

  const handleCCChange = id => {
    setCCNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(data && typeof data === "object" ? data.id : data)
    setPage(1)
    if (!data) {
      // Clear location.state
      navigate(location.pathname, { replace: true, state: {} })
    }
  }
  const handleLedgerChange = data => {
    setLedgerLocation(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchStoreHistory({
        params: `${search ? `&searchText=${search}` : "&searchText"}${ccNo ? `&costcenter_id=${ccNo}` : ""
          }${`&sortOrder=asc`}${type ? `&type=${type}` : ""}${projectId ? `&project_id=${projectId}` : ""
          }${datefrom ? `&start_date=${datefrom}` : ""}${dateto ? `&end_date=${dateto}` : ""
          }${productNo ? `&product_id=${productNo}` : ""}${company == true ? `&company_search=""` : ""
          }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${ledgerLocation ? `&ledger_id=${ledgerLocation}` : ""
          }`,
      })
      // setFetchedData(response)
      const newData = response?.data?.data || [];

      setFetchedData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
      // setHard(false)
      // ${`&financial=${financial}`}
    }
    if (
      datefrom &&
      dateto &&
      moment(datefrom).isSameOrBefore(moment(dateto)) &&
      productNo
    ) {
      fetchData()
    }
  }, [
    type,
    financial,
    ccNo,
    search,
    projectId,
    startDate,
    endDate,
    company,
    page,
    datefrom,
    dateto,
    productNo,
    ledgerLocation,
    dataPerPage,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [fetchedData, page]);

  // const handilHardResetApi = () => {
  //   setHard(true)
  // }

  const columns = [
    // {
    //       label: "Project Number",
    //       renderCell: item =>
    //         item?.project_id != null
    //           ? item?.project_id?.project_code
    //           : "Company Products",
    //     },
    {
      label: "Date",
      renderCell: item => (item?.date ? item?.date : "-"),
    },
    {
      label: "Particular",
      renderCell: item => (item?.reference ? item?.reference : "-"),
    },
    {
      label: "Location",
      renderCell: item =>
        item?.ledger_location?.name ? item?.ledger_location?.name : "-",
    },
    {
      label: "Units",
      renderCell: item => (item?.product?.unit?.unit_code ? item?.product?.unit?.unit_code : "-"),
    },
    {
      label: <div className="text-end pe-5">Opening Qty</div>,
      renderCell: item => (
        <>
          {item?.quantity ? (
            <div className="text-end pe-5">{`${item?.activity === "add" ? "+" : "-"
              } ${NumberFormat(Number(item?.opening_balance))}`}</div>
          ) : (
            <div>-</div>
          )}
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Inward Qty</div>,
      renderCell: item => (
        <>
          {item?.quantity ? (
            <div className="text-end pe-5">{`${item?.activity === "add" ? "+" : "-"
              } ${item?.activity == "add"
                ? NumberFormat(Number(item?.quantity))
                : "0"
              }`}</div>
          ) : (
            <div>-</div>
          )}
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Outward Qty</div>,
      renderCell: item => (
        <>
          {item?.quantity ? (
            <div className="text-end pe-5">{`${item?.activity === "remove" ? "-" : "+"
              } ${item?.activity == "remove"
                ? NumberFormat(Number(item?.quantity))
                : "0"
              }`}</div>
          ) : (
            <div>-</div>
          )}
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Closing Qty</div>,
      renderCell: item => (
        <>
          {item?.quantity ? (
            <div className="text-end pe-5">{`${item?.activity === "add" ? "+" : "-"
              } ${NumberFormat(Number(item?.closing_balance))}`}</div>
          ) : (
            <div>-</div>
          )}
        </>
      ),
    },
  ]

  const handleRequestdate = data => {
    console.log(data, "data")
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    console.log(fromDate, toDate, "toDate")
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleReset = () => {
    reset({ req_date: null })
    setStartDate("")
    setEndDate("")
  }

  const handleCompanyChange = id => {
    setCompany(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Inventory"
                breadcrumbObject={[
                  { title: "Inventory", link: "/inventory" },
                  { title: bookname ? bookname : crumb ? crumb : "Inventory Master", link: "/inventory" },
                  ...(bookname ? [{ title: "Products", link: "/inventory-product" }] : []),
                  {
                    title: "Inventory Book",
                    link: "#",
                  },
                ]}
              />
            ) : (
              <></>
            )}
          </div>

          <Card
            className={`me-2 px-2 pb-2 ${fromDashboard ? "dash-table-bg" : ""}`}
          >
            {fromDashboard ? (
              <div className="px-2 py-3">Transaction History</div>
            ) : (
              <StockJournalFilter
                // handleCCChange={handleCCChange}
                handleTypeChange={handleTypeChange}
                handleSearchChange={handleSearchChange}
                handleDateChange={handleDateChange}
                handleProductChange={handleProductChange}
                handleLedgerChange={handleLedgerChange}
                // handleTHChange={handleTHChange}
                handleFinacialChange={handleFinacialChange}
                handleCompanyChange={handleCompanyChange}
                // handilHardResetApi={handilHardResetApi}
                {...(location?.state && {
                  productId,
                  productName,
                  productCode,
                })}
              />
            )}
            <hr className="table-divide" />
            <div>
              {fromDashboard && (
                <Row className="pt-2">
                  <Col sm={6}>
                    <UFDate
                      control={control}
                      placeholder="Date"
                      name={"req_date"}
                      mode="range"
                      className="ufinput-dashboard"
                      onDateChange={e => handleRequestdate(e)}
                    />
                  </Col>
                  <Col sm={3}></Col>
                  <Col sm={3}>
                    <div
                      className="pointer me-2 text-white btn btn-primary float-end"
                      onClick={() => handleReset()}
                    >
                      <img
                        src={resetIcon}
                        height={15}
                        width={15}
                        className="me-2 svg-clr-reset"
                      />{" "}
                      Reset
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className={`ever-rise-table ${fromDashboard ? "dashboardTable" : ""
                  } `}
              >
                <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {fetchedData?.data?.data ? (
                    <>
                      {/* <div className="d-flex justify-content-between px-2 py-3 fw-600">
                        <div>
                          Opening Balance:{" "}
                          {NumberFormat(
                            Number(fetchedData?.opening_balance || 0),
                            desimalrange,
                            desimalrange
                          )}
                        </div>
                        <div>
                          Closing Balance:{" "}
                          {NumberFormat(
                            Number(fetchedData?.closing_balance || 0),
                            desimalrange,
                            desimalrange
                          )}
                        </div>
                      </div> */}

                      <UpdateTable
                        className="mt-5"
                        nodes={fetchedData?.data?.data}
                        paginate={fetchedData?.data}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleSizePerPage={handleSizePerPageChange}
                        tableWidth="15% 15% 15% 15% 10% 10% 10% 10%"
                        mobileWidth="50% 50% 50% 50%"
                        showFooter={true}
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                      />
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <p>Please select a Product and date.</p>
                    </div>
                  )}
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default StockJournalReport
